module.exports = __webpack_public_path__ + "static/media/fourOhFour.391bc070.png";